import BrandDashboard from "@panel/brand/dashboard";
import BrandPublishers from "@panel/brand/publishers";
import BrandPublisherInvoices from "@panel/brand/publishers/invoices";
import BrandDebitNotes from "@panel/brand/debit-note";
import BrandDisbursements from "@panel/brand/disbursements";
import BrandPublisherContract from "@panel/brand/publisher-contract";
import BrandSmtp from "@panel/brand/smtp";
import BrandGuide from "@panel/brand/guide";
import BrandIndexRedirect from "@panel/brand/index-redirect";
import BrandSetup from "@panel/brand/setup";

// Mirrors Nook Pay Hub's /brand/* routes (src/routes/brand.tsx), scoped to
// whichever brand is selected in the topbar switcher.
const BrandRoutes = [
    {
        path   : "brand",
        element: <BrandIndexRedirect />,
        meta   : {
            resource: "brand-dashboard",
            title   : "Brand Dashboard",
            action  : "read"
        }
    },
    {
        // Normal layout: the topbar has to stay reachable so a gated brand can still
        // be switched away from. The lock comes from the nav instead — while setup is
        // pending the sidebar carries this route and nothing else (see navigation).
        path   : "brand/:brandId/setup",
        element: <BrandSetup />,
        meta   : {
            resource: "brand-setup",
            title   : "Set up your workspace",
            action  : "read"
        }
    },
    {
        path   : "brand/:brandId/dashboard",
        element: <BrandDashboard />,
        meta   : {
            resource: "brand-dashboard",
            title   : "Brand Dashboard",
            action  : "read"
        }
    },
    {
        path   : "brand/:brandId/publishers",
        element: <BrandPublishers />,
        meta   : {
            resource: "brand-publishers",
            title   : "Brand Publishers",
            action  : "read"
        }
    },
    {
        path   : "brand/:brandId/publishers/:id/invoices",
        element: <BrandPublisherInvoices />,
        meta   : {
            resource: "brand-publishers",
            title   : "Publisher Invoices",
            action  : "read"
        }
    },
    {
        path   : "brand/:brandId/publisher-contract",
        element: <BrandPublisherContract />,
        meta   : {
            resource: "brand-publisher-contract",
            title   : "Contract",
            action  : "read"
        }
    },
    {
        path   : "brand/:brandId/debit-note",
        element: <BrandDebitNotes />,
        meta   : {
            resource: "brand-debit-notes",
            title   : "Brand Debit Notes",
            action  : "read"
        }
    },
    {
        // Self-payout counterpart of the debit-note screen — the publisher invoices
        // this brand settles itself (see use-brand-route-guard).
        path   : "brand/:brandId/disbursements",
        element: <BrandDisbursements />,
        meta   : {
            resource: "brand-disbursements",
            title   : "Disbursements",
            action  : "read"
        }
    },
    {
        path   : "brand/:brandId/smtp",
        element: <BrandSmtp />,
        meta   : {
            resource: "brand-smtp",
            title   : "Configure SMTP",
            action  : "read"
        }
    },
    {
        path   : "brand/:brandId/guide",
        element: <BrandGuide />,
        meta   : {
            resource: "brand-guide",
            title   : "Brand User Guide",
            action  : "read"
        }
    }
];

export default BrandRoutes;
